/**
 * Gen1 Dimmer device template
 * Used by: SHDM-1 (Dimmer), SHDM-2 (Dimmer 2)
 *
 * Gen1 dimmers use /device/light/control endpoint
 */

import {
	createGen1TurnAction,
	createGen1StateCondition,
	createGen1StateChangedTrigger,
} from './stateManagement.js';
import { createGen1BrightnessAction, createGen1BrightnessCondition } from './light.js';

export function createGen1SingleDimmerTemplate() {
	return {
		deviceType: 'gen1_single_dimmer',
		generation: 1,
		channels: ['light:0'],
		actions: {
			turn: createGen1TurnAction('light', false),
			setBrightness: createGen1BrightnessAction(),
		},
		conditions: {
			isOn: createGen1StateCondition('light'),
			brightnessLevel: createGen1BrightnessCondition(),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('light'),
		},
	};
}

export function createGen1DualDimmerTemplate() {
	return {
		deviceType: 'gen1_dual_dimmer',
		generation: 1,
		channels: ['light:0', 'light:1'],
		actions: {
			turn: createGen1TurnAction('light', false),
			setBrightness: createGen1BrightnessAction(),
		},
		conditions: {
			isOn: createGen1StateCondition('light'),
			brightnessLevel: createGen1BrightnessCondition(),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('light'),
		},
	};
}
